var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AdminUsersDetail"},[_c('WCard',[_c('EntityItemDetail',{attrs:{"value":_vm.user,"columns":_vm.columns}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }